module.exports = "/_next/static/images/sticky-desktop-37218e009f5cc8557bccda057e375aba.svg";